import { Row, Col, Button, Tabs } from 'antd';
import React, { useEffect } from 'react';
import { useGraph, useModel, useVista, Vista } from '@essenza/react';
import { UserModel } from '../models/model';
import { ProfileForm } from '../view/ProfileForm';
import { CompanyProfile } from '../view/CompanyProfile';

function ProfileVistaController(c) {
    c.skin = ProfileVista;
}

export function ProfileVista({ vmodel }) {
    const [ctx, control] = useVista(ProfileVistaController);
    const [model] = useModel();
    const user = useGraph(UserModel, "profile");

    useEffect(() => {
        console.log("MODEL ", model);
        if (model) {
            model.read(UserModel, m => m.profile());
        }
    }, [model]);

    if (!user.data) return null;

    return (
        <Vista context={ctx} >
            <div className="w100">
                <div className="centered max-width-sm text-center">
                    <Tabs defaultActiveKey="1" >
                        <Tabs.TabPane tab="Informazioni Aziendali" key="1">
                            <CompanyProfile source={user} npath="/offerta" />
                        </Tabs.TabPane>
                        <Tabs.TabPane tab="Informazioni Personali" key="2">
                            <ProfileForm source={user} npath="/offerta" />
                        </Tabs.TabPane>
                    </Tabs>
                    <div className="custom-form bg-pri round-sm mt-sm padding-xl text-center">
                        <a target="_blank" rel='noreferrer' href='https://www.ssati.it/wp-content/uploads/2023/06/2023_SSATI_infomrativa-privacy_placement_SOCIETA-e-ENTI.pdf'>Privacy Policy</a>
                    </div>
                    <div className="custom-form bg-pri round-sm my-sm padding-xl text-center">
                        <Button className='primaryButton' onClick={() => window.location.replace(window.location.origin + '/app')}>
                            Logout
                        </Button>
                    </div>
                </div>
            </div>
        </Vista>
    )
}